import script from "./UserModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserModal.vue?vue&type=script&setup=true&lang=ts"

import "./UserModal.vue?vue&type=style&index=0&id=1ab33ae2&scoped=true&lang=scss"

import exportComponent from "E:\\work\\EEEEE\\okpay\\ipay-imi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ab33ae2"]])

export default __exports__